import { api } from 'common';

import { FormV2BlockFormFields } from './FormFields';
import { formV2BlockDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';
import { getDefaultSchedulingConfigs } from '../Form/SchedulingConfigs/utils';

export const formV2Config: BlockConfigProps<api.FlowDefinition.FormV2Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'form',
  defaultConfig: {
    formTemplateConfigs: [],
    schedulingConfigs: getDefaultSchedulingConfigs(),
    isOverridingEntity: false,
    exportMode: api.PrevisitForm.ExportMode.RunAutoExport,
    mode: api.FlowDefinition.FormV2Mode.AddAndWaitForCompletion,
    timeout: {
      value: 1,
      units: api.FlowDefinition.DurationUnits.Days,
    },
    notificationSchemeIdOverride: null,
  },
  configFields: {
    schema: api.FlowDefinition.FormV2BlockConfigSchema,
    FormFields: FormV2BlockFormFields,
  },
  documentationMarkdown: formV2BlockDocumentationMarkdown,
};
